import Info from '@mui/icons-material/Info';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function InfoIcon(props: FixMe) {
  return <Info {...props} />;
}

export default InfoIcon;
